export enum JobType {
    INVENTORY = "INVENTORY",
    INTERNAL = "INTERNAL",
  }